<template>
  <div>
    <div v-if="shouldShowConsent" class="flex consent-page ">
      <div>
        <div class="space">
          <div />
          <div class="flex m-4 space-x-2">
            <div class="w-5 h-5">
              <logo-workkami />
            </div>
            <p class="text-sm font-normal text-gray-20">
              ลงชื่อเข้าใช้ด้วย Workkami
            </p>
          </div>
          <hr class="border-gray-primary" />

          <div class="grid grid-cols-2 font-normal">
            <p class="m-8 font-size28px text-brand-blue  font-semibold">
              ลงชื่อเข้าใช้งานใน {{ system }}
            </p>
            <div class="my-8 mr-8">
              <div class="text-base font-medium">
                <p>Workkami จะอนุญาตให้ {{ system }} เข้าถึงข้อมูล</p>
                <p>ซึ่งเกี่ยวกับคุณนี้</p>
              </div>
              <div class="flex space-x-4 my-4">
                <base-icon size="24">
                  <icon-user-circle />
                </base-icon>
                <div>
                  <p class="text-base">{{ name }}</p>
                  <p class="text-sm">ชื่อ และ ภาพโปรไฟล์</p>
                </div>
              </div>
              <div class="flex space-x-4  my-4">
                <base-icon size="24">
                  <icon-mail />
                </base-icon>
                <div>
                  <p class="text-base">{{ email }}</p>
                  <p class="text-sm">อีเมล</p>
                </div>
              </div>
              <p class="text-sm">
                อ่านนโยบายความเป็นส่วนตัวและข้อกำหนดในการให้บริการของ
                workkami.com เพื่อทำความเข้าใจวิธีที่ workkami.com
                จะประมวลผลและปกป้องข้อมูลของคุณ
              </p>
              <p class="my-4 text-sm font-semibold text-brand-blue">
                <router-link
                  class="color-brand"
                  :to="`/${$i18n.locale}/terms`"
                  data-testid="terms-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  อ่านนโยบาย
                </router-link>
              </p>
              <div class="flex space-x-6">
                <div class="w-full">
                  <base-button
                    full
                    color="white"
                    :disabled="loading"
                    data-testid="cancel-btn"
                    @click="cancel"
                  >
                    ยกเลิก
                  </base-button>
                </div>
                <div class="w-full">
                  <base-button
                    full
                    color="brand"
                    :disabled="loading"
                    data-testid="continue-btn"
                    @click="confirm"
                  >
                    ดำเนินการต่อ
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="background-left">
        <background-auth-left />
      </div>
      <div class="background-right">
        <background-auth-right />
      </div>
    </div>

    <div v-else>
      <div class="dark-overlay">
        <div class="lds-ripple">
          <div />
          <div />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackgroundAuthLeft from '@/components/icons/BackgroundAuthLeftConsent';
import BackgroundAuthRight from '@/components/icons/BackgroundAuthRightConsent';
import LogoWorkkami from '@/components/icons/LogoWorkkami';
import LoadingMixin from '@/mixins/LoadingMixin';
import IconUserCircle from '@/components/icons/IconUserCircle';
import IconMail from '@/components/icons/IconMail';
import { oAuthApi } from '@/services/apis';
import apis from '@/services/apis';
import firebase from '@/services/firebase';
import { mapActions } from 'vuex';

const STORAGE_BUSY = 'is-google-login-busy';
const IS_BUSY = 'on';

export default {
  components: {
    BackgroundAuthLeft,
    BackgroundAuthRight,
    LogoWorkkami,
    IconUserCircle,
    IconMail
  },
  mixins: [LoadingMixin],
  name: 'Consent',
  created() {
    if (this.hasStateAndCodeGoogle) this.checkLogin();
    else this.fetchContent();
  },
  data() {
    return {
      dataConsent: {},
      shouldShowConsent: false
    };
  },
  computed: {
    hasStateAndCodeGoogle() {
      const state = this.getUrlParameter(this.$route.fullPath, 'state');
      const code = this.getUrlParameter(this.$route.fullPath, 'code');
      return state && code;
    },
    name() {
      return this.dataConsent?.name || '-';
    },
    email() {
      return this.dataConsent?.email || '-';
    },
    system() {
      return this.dataConsent?.system || '-';
    },
    callbackUrl() {
      const url = `${window.location.protocol}//${window.location.hostname}/${this.$i18n.locale}`;
      return `${url}/consent`;
    },
    clientId() {
      return '827661701883-6i99sh9efmi6163hihigibd6dng18ipi.apps.googleusercontent.com';
    }
  },
  methods: {
    ...mapActions('auth', [
      'login',
      'logout',
      'loginOAuth',
      'clearSessionOAuth',
      'callBackOAuthRedirect'
    ]),
    getUrlParameter(url, name) {
      name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      const results = regex.exec(url);
      return results === null
        ? ''
        : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    async checkLogin() {
      const state = this.getUrlParameter(this.$route.fullPath, 'state');
      const code = this.getUrlParameter(this.$route.fullPath, 'code');
      if (state == 'google_signin') {
        this.$emit('click');
        localStorage.setItem(STORAGE_BUSY, IS_BUSY);
        try {
          const form = new FormData();
          form.append('code', code);
          form.append('client_id', this.clientId);
          form.append('client_secret', 'hV-JaL2xueJoeVw54o1yK4tg');
          form.append('redirect_uri', `${this.callbackUrl}`);
          form.append('grant_type', 'authorization_code');
          const { data } = await apis.post(
            `https://oauth2.googleapis.com/token`,
            form,
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          );
          if (data.id_token) {
            this.loginGoogleSuccess({
              wc: {
                id_token: data.id_token,
                access_token: data.access_token
              }
            });
          }
        } catch (error) {
          window.location.replace(this.callbackUrl);
        }
      }
    },
    async loginGoogleSuccess(googleUser) {
      if (googleUser.wc && googleUser.wc.id_token) {
        this.$emit('click');
        const idToken = googleUser.wc.id_token;
        const accessToken = googleUser.wc.access_token;
        const provider = new firebase.auth.GoogleAuthProvider();
        const credential = provider.credential(idToken, accessToken);
        firebase
          .auth()
          .signInWithCredential(credential)
          .then(({ user }) => {
            return firebase
              .auth()
              .currentUser.getIdToken(true)
              .then(idToken => ({ idToken, email: user.email, loginType: 3 }));
          })
          .then(loginInfo => {
            const { loginType = 1, idToken, email = this.email } = loginInfo;
            const loginRequest = {
              loginType,
              idToken,
              email,
              password: this.password
            };
            this.logInWithOAuth(loginRequest);
            return;
          });
      }
    },
    async logInWithOAuth(loginRequest) {
      try {
        const res = await this.loginOAuth(loginRequest);
        if (res.status === 200) {
          this.shouldShowConsent = res.data.consent;
          await this.fetchContent();
        }
      } catch (error) {
        this.errorMessage(error);
      }
    },
    errorMessage(error) {
      const defaultError = this.$t('fail.try_again', {
        do: this.$t('login.name').toLowerCase()
      });
      this.error = error?.response?.data?.message || defaultError;
    },
    async fetchContent() {
      try {
        const res = await oAuthApi.consent.index();
        this.dataConsent = res?.data;
        this.shouldShowConsent = true;
      } catch (error) {
        const getRedirectUri = this.getQuery?.redirectURI;
        if (getRedirectUri)
          window.location.href = `https://${getRedirectUri}?error=consent`;
        this.errorMessage(error);
      }
    },
    async cancel() {
      this.onLoading();
      try {
        const res = await oAuthApi.consent.delete();
        if (res?.status == 200) {
          const uri = res?.data?.uri;
          const state = res?.data?.state;
          this.clearSessionOAuth();
          const url = new URL(`https://${uri}`);
          url.searchParams.set('state', state);
          window.location.href = url.toString();
        }
      } catch (error) {
        this.errorMessage(error);
      } finally {
        this.offLoading();
      }
    },
    async confirm() {
      this.onLoading();
      try {
        const res = await oAuthApi.consent.create();
        if (res?.status == 200) {
          await this.callBackOAuthRedirect();
        }
      } catch (error) {
        this.errorMessage(error);
      } finally {
        this.offLoading();
      }
    },
    clearSessionOAuth() {
      this.$store.dispatch('auth/clearSessionOAuth');
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;600;700&display=swap');

.font-size28px {
  font-size: 28px;
}
.consent-page {
  font-family: 'Sarabun', sans-serif;
  @apply relative h-screen flex items-center justify-center;
}
.consent-page > div:nth-child(1) {
  z-index: 10;
  @apply max-w-3xl w-full;
}
.consent-page .space {
  @apply rounded border border-gray-300 w-full bg-white;
}
.consent-page .background-left {
  @apply absolute bottom-0 left-0 z-0;
}
.consent-page .background-right {
  @apply absolute bottom-0 right-0 z-0 hidden;
}
@media (min-width: 1024px) {
  .login-page div.left {
    @apply flex;
  }
  .consent-page .background-right {
    @apply block;
  }
}
</style>
